<template lang="pug">
  .document-list.relative
    div(v-if="loading == false")
      loading(:active.sync="loading" :is-full-page="false")
      Tabs(name="tabs" :start_active="tabs[0]" :tabs="tabs")
        template(v-slot:introduction)
          p Welcome to Positive People HR’s Compliance For You portal. The purpose of this portal is to provide you with the information and documents you need to ensure you are compliant when you take on an employee for the first time, or to ensure that, if you have employees already that everything is in place.
          p The portal has seven sections that take you through the stages of the employee life cycle, it covers the key things to consider but does not cover everything.
          p Please click on each section for more information.
          DocumentListSection(:data="data" name="Introduction")
          .service-list-box
            .inner
              h2 Our Other Services
              hr
              Flexible.jleft
                ServiceBox
                  h2 Telephone Advice
                  p If any of these documents are unclear, or if you require some assistance, please give us a call and your first 30 minutes will be free.
                  p If you wish to have continued telephone support, we can talk to you about our HR Retained Service.
                ServiceBox
                  h2 Retained HR Services
                  p Positive People HR provides a cost-effective monthly subscription service called a 'retained service'. The service includes a series of flexible offerings that help you manage effectively employee issues that arise every day in businesses, this can include a telephone advice line, documents supporting the advice being given and on-site support at meetings that relate specifically to the advice being given.
                ServiceBox
                  h2 On-Site HR Support
                  p Our-onsite HR support service allows you to buy-in a number of hours per week which are flexible to the needs of your business, whilst we are on site we can carry out any day to day HR/people management activity to ensure you remain compliant and deal effectively with employee issues/challenges.
                ServiceBox
                  h2 HR Director Service
                  p This service supports the business from a more strategic position, providing advice to the Directors, analysing people metrics and identifying initiatives to improve performance.
                  p To drive and own the People Strategy and make fundamental contributions to the organisation's culture, development, and exceptional staffing.
        template(v-slot:recruitment)
          h2.title 1.	Recruitment
          p The recruitment section includes a checklist to help you consider the steps to take to ensure that your process is effective and that all the legal elements have been thought through. There is an application form that you can use to gather information about your new employee, such as reference information and there is also a letter that you can use to ask previous employers for a reference.
          p This section also includes an offer letter and employment contract template which you can use to ensure that you comply with the obligation you have of issuing details of the new employees’ terms and conditions which you need to do within eight weeks of someone starting employment with you. There is also a template Company Handbook which contains the main policies that you need to ensure you can manage employee’s questions about how you deal with things and provide the employee with all relevant information regarding policies and procedures. Please note this is a generic template and you will need to amend this to be relevant to your business.
          p One of the most important things that we believe helps with onboarding an employee once you have made an offer to someone is to have a great induction process and in this portal we have included an onboarding and induction checklist. These documents will really help you engage with your new employee in a positive way. 
          p If you decide to provide Life Assurance/Death in Service Cover you will need to ask your employee to complete a Nomination of Beneficiaries form which is included in this portal and should be kept on the employees file.
          DocumentListSection(:data="data" name="Recruitment")
        template(v-slot:probation_periods)
          h2.title Probation Periods
          p In the contract of employment, we have suggested that there is a probationary period of three months. In the portal we have included a probationary review form that can be used to assess the new employee’s performance within that period and sign them out of their period of probation. There is also a letter you can use to confirm that they have passed their probation period and are now a permanent member of your team.   
          DocumentListSection(:data="data" name="Probation Periods")
        template(v-slot:absence)
          h2.title Absence
          p There are two types of absence, planned and unplanned. 
          p A planned absence is usually a request for holiday or an appointment of some kind. In the handbook there is a policy for managing absence which details different types of absence. You will find in this portal a holiday request form which will allow you to keep a record of what has been requested and when it was approved.
          p The other forms are a self-certification form and a return to work form.
          ul
            li Self-Certification form – This should be completed by the employee upon their return from a sickness absence to confirm what the absence is for and once completed should be kept on the employee’s personnel file.
            li Return to work – When an employee returns from a sickness absence, you should use it to carryout a meeting following a return from absence. The form allows you to document a conversation with an employee and highlight where there might become absence issues. Documenting these meetings means that they can be used if an absence becomes unacceptable and formal meetings are held.
          p Other types of absence include maternity leave, paternity leave and parental leave, these are all included in the Company Handbook.
          DocumentListSection(:data="data" name="Absence")
        template(v-slot:useful_forms)
          h2.title Useful Forms
          ol
            li Performance Review Form – This can be used to carry out and document meetings with employees about performance, not just if improvement is required but to help motivate the employee by giving feedback on positive performance.
            li Flexible Working Request Form – If an employee has completed 26 weeks of service they are entitled to make a flexible working request. This form is used by the employee to make this request. Please be aware that there is a process you need to follow if an employee makes a request. An employee can only make one request for flexible working within any 12 month period.
            li Maternity Request Form – This form is to be used by the employee to advise you that they are pregnant.
            li Paternity Request Form – Every employee whose partner is due to have a child and they are the dependent is entitled to take two weeks paternity leave. This form can be used for them to make this request and provide the information needed. 
            li Display Screen Equipment (DSE) Assessment Form – Under health and safety, if your employee uses a PC/Screen for long periods of time, they should complete this form. This confirms you have undertaken your obligations in relation to how they use the equipment around them.
          p NB – Our advice is that anything that you agree with an employee is confirmed in writing, either a letter or by email that is also put on their employee file. 
          DocumentListSection(:data="data" name="Useful Forms")
        template(v-slot:gdpr)
          h2.title General Data Protection Regulations (GDPR) 
          p These new updated regulations came into force in May 2018 and gives a requirement for employers to be transparent about what employee data is captured, how it is processed, the reasons and how it is stored. 
          p The Employee Privacy Policy outlines how the individual’s data is dealt with and the Data Protection Policy outlines the approach to data generally in the business and how employee’s should comply.
          DocumentListSection(:data="data" name="GDPR")
        template(v-slot:payroll)
          h2.title Payroll
          p The payroll form is quite simply to collect the data you need to provide to the person who provides payroll support.
          DocumentListSection(:data="data" name="Payroll")
        template(v-slot:leaving)
          h2.title Leaving The Organisation
          p In this section there is a letter which can be used to confirm acceptance of a resignation should an employee wish to leave your company. 
          DocumentListSection(:data="data" name="Leaving")
        template(v-slot:covid-19_-_employer_support)
          h2 COVID-19 - Employer Support
          p This section is focussed on providing help, advice and support in relation to Coronavirus (CO-VID19), giving you access to Information/guidance, temporary or new policy templates and letter templates. Using this portal will help you comply with employment legislation whilst dealing with the various situations that are arising during this challenging time for employer’s.
          p As the situation develops we will keep you up to speed on any changes and we will also update the portal as things return to normal to help you reengage your employees back into their jobs and back to the working environment.
          br
          p Also if you sign up to this service you will have access to our telephone helpline which you can call for specific advice.
          p We hope you find this helpful and please contact us if you need any support.
          DocumentListSection(:data="data" name="COVID-19 - Employer Support")
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import TabsComponent from '@/components/Tabs'
  import Thumbnail from '@/components/documents/Thumbnail'
  import DocumentListSection from '@/components/documents/DocumentListSection'

  import ServiceBox from '@/components/services/ServiceBox'

  import DocumentService from '@/services/document'
  import Notice from '@/components/Notice'

  export default {
    components: { 
      'Tabs': TabsComponent,
      DocumentListSection,
      Loading,
      ServiceBox,
      Notice,
      Thumbnail
    },
    data: function() {
      return {
        service: DocumentService,
        tabs: ['introduction','recruitment','probation_periods','absence','useful_forms','gdpr','payroll','leaving','covid-19_-_employer_support'],
        data: [],
        loading: true,
        error: ''
      }
    },
    methods: {
      async GET_DATA() {
        try {
          this.loading = true;
          const response = await DocumentService.get_all();

          if(response) {
            if(response.data)
              this.$emit('success', response.data);
            return true;
          }

        } catch(err) {
          if(err.response)
            if(err.response.status)
              this.forceLogout();
          this.loading = false;
        }
      }
    },
    created() {
      this.$on('loading', function (e) {
        this.loading = e;
      });
      this.$on('error', function (e) {
        this.error = e;
      });
      this.$on('success', function (e) {
        this.data = e;
        this.loading = false;
        this.error = '';
      });
      this.GET_DATA();
    },
    watch: {
      '$route' (to, from) {
        if(to.name != from.name) {
          this.GET_DATA();
        }
      }
    }
  }
</script>

<style lang="scss">

</style>